<form
  class="form"
  #availabilityform="ngForm"
  (ngSubmit)="availabilityform.form.valid && onSubmit()"
  novalidate
>
  <div class="row">

    <div class="col-md-4">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <input
            #inputfocus
            autofocus
            [matDatepicker]="availabilitydatepicker"
            matInput
            (click)="availabilitydatepicker.open()"
            placeholder="Date"
            [min]="today"
            required
            [(ngModel)]="availabilityFormValue.from_date"
            name="availabilitydate"
            autocomplete="off"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="availabilitydatepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #availabilitydatepicker
            disabled="false"
            color="primary"
            touchUi
          ></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <input
            matInput
            placeholder="From Time"
            required
            [(ngModel)]="availabilityFormValue.timing.from_time"
            type="time"
            name="from_time"
            autocomplete="off"
          />
          <mat-error *ngIf=""></mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <input
            matInput
            placeholder="To Time"
            required
            [(ngModel)]="availabilityFormValue.timing.to_time"
            type="time"
            name="to_time"
            autocomplete="off"
          />
          <mat-error *ngIf=""></mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <mat-select
            placeholder="Type"
            required
            [(ngModel)]="availabilityFormValue.available_type"
            name="type"
          >
            <mat-option
              *ngFor="let item of typeList; index as i"
              [value]="item"
              >{{ item }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div style="text-align: center">
    <button
      type="submit"
      mat-raised-button
      class="btn btn-primary"
      [disabled]="!availabilityform.valid"
      color="primary"
    >
      {{ formtype ? 'Update' : 'Save' }}
    </button>
    &nbsp;&nbsp;&nbsp;
    <a
      (click)="viewAvailabilitylist()"
      mat-raised-button
      class="btn btn-light-primary btn-bold"
    >
      Cancel
    </a>
  </div>
</form>
